/* eslint-disable react/prop-types */
import React from 'react';

// REDUX
import { connect } from 'react-redux';
import * as elementsActions from '../../redux/actions/elements';

import styles from './Warning.module.scss';

const Warning = (props) => {
  const { history, setViewCheck } = props;
  const browserMobileView = window.innerWidth <= 500; // eslint-disable-line
  return (
    <div className={styles.warningWrapper}>
      <div className={styles.warningContainer}>
        <h2>Warning</h2>
        <p>
          For the best prototype experience, please view
          this application on a mobile view.
        </p>
        <p>
          If on a desktop browser, please adjust your window
          width to a mobile view of less than 500px and refresh this screen.
        </p>
        <button
          onClick={() => {
            history.push('/');
              setViewCheck(false);
            }}
            type="button"
          >
            Continue
          </button>
      </div>
    </div>
  );
};


const mapDispatchToProps = (dispatch) => ({
  setViewCheck: (value) => dispatch(elementsActions.setViewCheck(value)),
});


export default connect(null, mapDispatchToProps)(Warning);
